import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

interface WhatsAppButtonProps {
  /** When true, renders a completely static version (no animations) */
  iosPortrait?: boolean;
}

export function WhatsAppButton({ iosPortrait = false }: WhatsAppButtonProps) {
  // Static version for iOS portrait - no Framer Motion, no CSS animations
  if (iosPortrait) {
    return (
      <a
        href="https://api.whatsapp.com/send?phone=2347065732481"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="fixed right-6 z-50 flex items-center gap-3 bg-primary text-primary-foreground px-5 py-3 rounded-full shadow-lg"
        style={{ bottom: "calc(5rem + env(safe-area-inset-bottom, 0px))" }}
      >
        <MessageCircle className="h-6 w-6" />
        <span className="font-medium text-sm hidden sm:inline">Chat with us</span>
      </a>
    );
  }

  // Animated version for all other cases
  return (
    <motion.a
      href="https://api.whatsapp.com/send?phone=2347065732481"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed right-6 z-50 flex items-center gap-3 bg-primary text-primary-foreground px-5 py-3 rounded-full shadow-lg hover:shadow-xl hover:bg-primary/90 transition-all duration-300 group"
      style={{ bottom: "calc(5rem + env(safe-area-inset-bottom, 0px))" }}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <motion.div
        animate={{ rotate: [0, 15, -15, 0] }}
        transition={{ repeat: Infinity, duration: 2, repeatDelay: 3 }}
      >
        <MessageCircle className="h-6 w-6" />
      </motion.div>
      <span className="font-medium text-sm hidden sm:inline">Chat with us</span>
      
      {/* Ping animation */}
      <span className="absolute -top-1 -right-1 flex h-4 w-4">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
        <span className="relative inline-flex rounded-full h-4 w-4 bg-white/30"></span>
      </span>
    </motion.a>
  );
}
